import React from "react";
// import { IAppContext } from "src/types/appContextInterface";
import { initialAppState } from "./initialAppState";
import { IAppContext } from "../types/appContextInterface";

const AppContext = React.createContext<IAppContext>({
  globalState: initialAppState,
  dispatch: null,
});

export default AppContext;
